import { createAction, props } from '@ngrx/store';
import { Params } from '@angular/router';

export const updateSearchQueryParams = createAction(
  '[Search] Update search query params',
  props<{
    params: Params;
  }>(),
);
